import { render, staticRenderFns } from "./Industry.vue?vue&type=template&id=d27e20f4&"
import script from "./Industry.vue?vue&type=script&lang=js&"
export * from "./Industry.vue?vue&type=script&lang=js&"
import style0 from "./Industry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports